var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show && _vm.dataFilled
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", [
          _c("div", { staticClass: "title-container" }, [
            _c("div", [
              _c(
                "h4",
                [
                  _vm.title
                    ? _c("span", [_vm._v(_vm._s(_vm.title))])
                    : _vm.characteristic
                    ? _c("Label", {
                        attrs: { characteristic: _vm.characteristic }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.supplements
                    ? [_vm._v("(" + _vm._s(_vm.supplements) + ")")]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "close-container" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.closeFan(false)
                    }
                  }
                },
                [_c("Icon", { attrs: { icon: "close" } })],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _c("Edit", {
              attrs: {
                item: _vm.item,
                "experience-config": _vm.experienceConfig,
                "self-assessment-config": _vm.selfAssessmentConfig,
                "education-config": _vm.educationConfig,
                type: _vm.type
              },
              on: { change: _vm.onAdditionChange }
            }),
            _vm._v(" "),
            _vm.type === "application"
              ? _c(
                  "div",
                  { staticClass: "characteristic-addition-fan--info" },
                  [_c("NoExperienceInfo")],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _c("Button", {
              attrs: { text: "OK", disabled: !_vm.valid, icon: "checkmark" },
              on: {
                click: function($event) {
                  return _vm.closeFan(true)
                }
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }